<template>
    <div>
        <b-row class="pb-2">
            <b-col>
                <app-detalhe titulo="Filial" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.filialRMDto.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo Contrato" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.tipoContratoRMDto.descricao
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Status Contrato" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.statusContratoRMDto.descricao
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Natureza Contrato" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.naturezaContratoRMDto.descricao
                            : ''
                    }}</strong>
                </app-detalhe>
                <!-- <app-detalhe titulo="Tipo Faturamento" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.tipoProdutoFaturamentoRmDto
                                  .descricao
                            : ''
                    }}</strong>
                </app-detalhe> -->
                <app-detalhe titulo="Classif. Natureza" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.tipoNaturezaDto.descricao
                            : ''
                    }}</strong>
                </app-detalhe> 
                <app-detalhe titulo="Gestor do Contrato" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.gestorContrato.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Gerente do Gestor" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.gerenteGestor.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <!--<app-detalhe titulo="Representante" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.representanteRMDto.nome
                            : ''
                    }}</strong>
                </app-detalhe> -->
                <app-detalhe titulo="Tipo do rateio" :xl="xl">
                    <strong>Rateio definido no contrato</strong>
                </app-detalhe>
                <app-detalhe titulo="Tipo do Movimento" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.tipoMovimento : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Departamento" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.departamentoRMDto.nome : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Conta" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.contaRMDto.descricao : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Despesa/Receita" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.despesaReceitaRMDto.descricao : '' }}
                    </strong>
                </app-detalhe>
            </b-col>
            <b-col>
                <app-detalhe titulo="Condição de pagamento" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.condicaoPagamentoRMDto.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Condição de Pagamento a Prazo" :xl="xl">
                    <strong>{{
                        contrato.dadosContratoRM
                            ? contrato.dadosContratoRM.condicaoPagamentoPrazoRMDto.nome
                            : ''
                    }}</strong>
                </app-detalhe>
                <app-detalhe titulo="Quantidade de Faturamento" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.qtdFaturamento : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Dia de Faturamento" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.diaFaturamento : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Dias para Carência de Faturamento" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.diasCarenciaFaturamento : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Dias para Cancelamento da Carência de Faturamento" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.diasCarenciaCancFaturamento : '' }}
                    </strong>
                </app-detalhe>
                <!-- <app-detalhe titulo="Campo livre 1" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.campoLivre1 : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Campo Livre 2" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.campoLivre2 : '' }}
                    </strong>
                </app-detalhe>
                <app-detalhe titulo="Campo livre 3" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.campoLivre3 : '' }}
                    </strong>
                </app-detalhe> -->
                <app-detalhe titulo="Observação" :xl="xl">
                    <strong>
                        {{ contrato.dadosContratoRM ? contrato.dadosContratoRM.observacao : '' }}
                    </strong>
                </app-detalhe>    
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            xl: 4,
            // dadosContratoRM: {
            //     tipoContratoRMDto: {
            //         descricao: ''
            //     },
            //     tipoProdutoFaturamentoRmDto: {
            //         descricao: ''
            //     },
            //     tipoNaturezaDto: {
            //         descricao: ''
            //     },
            //     gestorContrato: {
            //         nome: ''
            //     },
            //     gerenteGestor: {
            //         nome: ''
            //     },
            //     representanteRMDto: {
            //         nome: ''
            //     }
            // }
        }
    },

    methods: {
        // obterDadosRM() {
        //     ContratoRmServicos.obterDadosContratoRM(
        //         this.$route.params.contratoId
        //     ).then(response => {
        //         if (response) {
        //             if (response.success) {
        //                 console.log(this.contrato.dadosContratoRM)
        //                 this.dadosContratoRM = this.contrato.dadosContratoRM
        //             }
        //         }
        //     })
        // }
    },

    computed: {},

    created() {
        //this.obterDadosRM()
    },

    components: {}
}
</script>
